import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FileText, TrendingUp, Clock, BarChart3 } from 'lucide-react';
export function AuthorityBlock() {
  return <section id="resources" className="bg-cool-gray overflow-hidden" data-id="element-25">
      {/* Full-Width Case Study Section */}
      <div className="bg-midnight-navy py-24 md:py-32 relative overflow-hidden" data-id="element-26">
        <div className="absolute top-0 right-0 w-[50%] h-full bg-accent-red/5 skew-x-12 translate-x-32 pointer-events-none" data-id="element-27" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-red/10 rounded-full -ml-32 -mb-32 blur-3xl pointer-events-none" data-id="element-28" />

        <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-29">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-30">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="space-y-8" data-id="element-31">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-red/20 text-accent-red rounded-full text-sm font-bold uppercase tracking-widest border border-accent-red/30" data-id="element-32">
                <FileText className="w-4 h-4" data-id="element-33" />
                Featured Case Study
              </div>

              <h2 className="text-stark-white text-4xl md:text-6xl font-manrope font-bold leading-tight" data-id="element-34">
                How "The Daily Grill" reclaimed{' '}
                <span className="text-accent-red" data-id="element-35">4.2%</span> of their net
                margin in 60 days.
              </h2>

              <p className="text-stark-white/70 text-xl leading-relaxed max-w-xl" data-id="element-36">
                Discover how a multi-unit group used ROI's predictive analytics
                to identify hidden waste patterns and optimize their regional
                supply chain.
              </p>

              <div className="grid sm:grid-cols-3 gap-8 py-8 border-y border-white/10" data-id="element-37">
                <div className="space-y-2" data-id="element-38">
                  <div className="text-accent-red font-manrope font-extrabold text-3xl" data-id="element-39">
                    +4.2%
                  </div>
                  <div className="text-stark-white/40 text-xs font-bold uppercase tracking-widest" data-id="element-40">
                    Margin Lift
                  </div>
                </div>
                <div className="space-y-2" data-id="element-41">
                  <div className="text-stark-white font-manrope font-extrabold text-3xl" data-id="element-42">
                    60 Days
                  </div>
                  <div className="text-stark-white/40 text-xs font-bold uppercase tracking-widest" data-id="element-43">
                    Implementation
                  </div>
                </div>
                <div className="space-y-2" data-id="element-44">
                  <div className="text-stark-white font-manrope font-extrabold text-3xl" data-id="element-45">
                    $124k
                  </div>
                  <div className="text-stark-white/40 text-xs font-bold uppercase tracking-widest" data-id="element-46">
                    Annual Savings
                  </div>
                </div>
              </div>

              <div className="pt-4" data-id="element-47">
                <Link to="/resources" className="inline-flex items-center gap-3 bg-accent-red text-stark-white px-8 py-4 rounded-full font-bold hover:bg-red-700 transition-all shadow-xl shadow-accent-red/20 group" data-id="element-48">
                  Read the full story
                  <motion.span animate={{
                  x: [0, 5, 0]
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity
                }} className="text-xl" data-id="element-49">
                    →
                  </motion.span>
                </Link>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            ease: 'easeOut'
          }} className="relative" data-id="element-50">
              <div className="bg-stark-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-3xl shadow-2xl" data-id="element-51">
                <div className="space-y-8" data-id="element-52">
                  <div className="flex items-center justify-between border-b border-white/10 pb-6" data-id="element-53">
                    <div className="flex items-center gap-4" data-id="element-54">
                      <div className="w-12 h-12 bg-accent-red rounded-xl flex items-center justify-center" data-id="element-55">
                        <TrendingUp className="w-6 h-6 text-stark-white" data-id="element-56" />
                      </div>
                      <div data-id="element-57">
                        <div className="text-stark-white font-bold" data-id="element-58">
                          Margin Optimization
                        </div>
                        <div className="text-stark-white/40 text-xs uppercase tracking-widest" data-id="element-59">
                          Live Performance
                        </div>
                      </div>
                    </div>
                    <div className="text-right" data-id="element-60">
                      <div className="text-green-400 font-bold" data-id="element-61">+18.4%</div>
                      <div className="text-stark-white/40 text-[10px] uppercase tracking-widest" data-id="element-62">
                        Efficiency
                      </div>
                    </div>
                  </div>

                  <div className="h-48 flex items-end gap-3" data-id="element-63">
                    {[30, 45, 35, 60, 55, 80, 75, 95, 85, 100].map((h, i) => <motion.div key={i} initial={{
                    height: 0
                  }} whileInView={{
                    height: `${h}%`
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 1,
                    delay: 0.5 + i * 0.1
                  }} className="flex-1 bg-accent-red/20 hover:bg-accent-red transition-colors rounded-t-sm" data-id="element-64" />)}
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-65">
                    <div className="p-4 bg-white/5 rounded-2xl border border-white/5" data-id="element-66">
                      <div className="flex items-center gap-2 text-stark-white/40 text-[10px] uppercase font-bold mb-1" data-id="element-67">
                        <Clock className="w-3 h-3" data-id="element-68" /> Time Saved
                      </div>
                      <div className="text-xl font-bold text-stark-white" data-id="element-69">
                        14h/week
                      </div>
                    </div>
                    <div className="p-4 bg-white/5 rounded-2xl border border-white/5" data-id="element-70">
                      <div className="flex items-center gap-2 text-stark-white/40 text-[10px] uppercase font-bold mb-1" data-id="element-71">
                        <BarChart3 className="w-3 h-3" data-id="element-72" /> ROI Status
                      </div>
                      <div className="text-xl font-bold text-accent-red" data-id="element-73">
                        Active
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Authority Block Section */}
      <div className="py-24 md:py-32" data-id="element-74">
        <div className="max-w-4xl mx-auto px-6" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="bg-stark-white p-12 md:p-20 shadow-xl border border-gray-200 text-center space-y-8 relative overflow-hidden" data-id="element-76">
            <motion.div initial={{
            height: 0
          }} whileInView={{
            height: '100%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: 0.5,
            ease: 'circOut'
          }} className="absolute top-0 left-0 w-2 bg-accent-red" data-id="element-77" />
            <h2 className="text-midnight-navy text-3xl md:text-4xl font-manrope font-bold" data-id="element-78">
              Built Around Real Restaurant Operations.
            </h2>
            <p className="text-midnight-navy/70 text-xl leading-relaxed" data-id="element-79">
              ROI was created from years of hands-on restaurant operational
              experience — built specifically around the day-to-day realities
              restaurant owners face. This isn’t generic software built by
              people outside the industry. It’s designed for operators.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}